require.register("local-data/assessments/phd-qafeedback-HE", function(exports, require, module){
  module.exports = {
    "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
    "questions": [
      {
        "id": 1,
        "text": "What should you do?",
        "correct_answer": "A",
        "answers": [
          { "id": "A", 
            "text": "Tell the student you’ll look into it and ask if there’s anything helpful you can do in the short term.", 
            "correct": true, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "success feedback"}]
                }]
              }
            }
          },
          { "id": "B",
            "text": "Explain that you can’t control the building’s structure, but offer to email the slides after the lecture is over.",
            "correct": false,
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          }
        ]
      }
    ]
  };
  
});

